import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as XLSX from "xlsx";
import FileSaver from "file-saver";

// Material-UI Core
import {
  withStyles,
  makeStyles,
  createStyles,
  useTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";
import { createMuiTheme } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Switch from "@material-ui/core/Switch";
import FormGroup from "@material-ui/core/FormGroup";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Checkbox from "@material-ui/core/Checkbox";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import Select from "@material-ui/core/Select";
import NativeSelect from "@material-ui/core/NativeSelect";
import Tooltip from "@material-ui/core/Tooltip";
import Fab from "@material-ui/core/Fab";
import Chip from "@material-ui/core/Chip";

// Material-UI Lab
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";

// Material-UI Icon

import SaveIcon from "@material-ui/icons/Save";
import AddIcon from "@material-ui/icons/Add";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import LibraryAddCheckIcon from "@material-ui/icons/LibraryAddCheck";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import CloseIcon from "@material-ui/icons/Close";
import ReplayIcon from "@material-ui/icons/Replay";
import RotateLeftIcon from "@material-ui/icons/RotateLeft";

// Custom Component
import DataImportDropzoneContent from "./DataImportDropzoneContent";
import DrawingFileDropZone from "../FileDropzone/DrawingFileDropZone";
import Legend from "../Legend/Legend";
import LockScreenLoading from "../LockScreenLoading/LockScreenLoading";
import { Alert } from "../Alert/Alert";
import ConfirmDialog from "../Dialog/ConfirmDialog";
import useLoading from "../Loading/useLoading";
import FullScreenDialog from "../Dialog/FullScreenDialog";
import WebViewer from "../WebViewer/WebViewer";

// Material-UI Element
// import {MuiPickersUtilsProvider, KeyboardDatePicker} from "@material-ui/pickers"

// Custom Style
import {
  redColor,
  oceanBlueColor,
  grayColor,
  whiteColor,
  blackColor,
  DodgerBlueColor,
} from "../../styles/jss/cmsMainStyle";
import unpublishDetailStyle from "../../styles/jss/components/drawingRegister/unpublishDetailStyle";

// Fetch Data
import {
  getPurposeType,
  getDrawingTypeAndGroup,
  getUnpublishDetail,
  saveUnpublish,
  publishDrawing,
  deleteUnpublish,
} from "../../dataSource/drawingRegister";

const PurposeTypography = withStyles({
  root: {
    fontSize: 13,
    fontWeight: 600,
    // "color": "#ff3399"
  },
})(Typography);

const ValidationErrorMsgTypography = withStyles({
  root: {
    fontSize: 12,
    fontWeight: 400,
    color: redColor[6],
  },
})(Typography);

const SelectMenuItem = withStyles((theme) =>
  createStyles({
    root: {
      "&$selected": {
        backgroundColor: oceanBlueColor[8],

        "&:hover": {
          color: whiteColor,
          backgroundColor: oceanBlueColor[12],
        },
      },

      "&:hover": {
        backgroundColor: oceanBlueColor[1],
      },
    },
    selected: {},
  })
)(MenuItem);

const drawingPanelTheme = createMuiTheme({
  overrides: {
    MuiAccordionSummary: {
      root: {
        backgroundColor: oceanBlueColor[0],

        "&$expanded": {
          backgroundColor: oceanBlueColor[10],
          color: blackColor,

          boxShadow:
            "0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12)",

          // "& .MuiAccordionSummary-expandIcon": {
          //   color: blackColor
          // }
        },

        // ".MuiExpansionPanelDetails-root &$expanded": {
        // 	backgroundColor: "transparent",
        // 	color: "black",
        // 	"& .MuiExpansionPanelSummary-expandIcon": {
        // 		color: defaultTheme.palette.action.active
        // 	}
        // }
      },
    },
  },
});

const useStyles = makeStyles((theme) => unpublishDetailStyle(theme));

const UnpublishDetail = (props) => {
  const { unpublishSeq, setRefashUnpublishRecord, closeUnpublishDetail } =
    props;
  const store = require("store");
  const classes = useStyles();
  const dispatch = useDispatch();
  const theme = useTheme();

  // Redux Data
  const unpublishDetailRedux = useSelector(
    (state) => state.unpublishDetailRedux
  );

  // Loading
  const [
    getUnpublishDetailLoading,
    getUnpublishDetailShowLoading,
    getUnpublishDetailHiddenLoading,
  ] = useLoading();

  // State Variable
  const [expanded, setExpanded] = useState(false);
  const [purposeType, setPurposeType] = useState(null);
  const [dwgTypeGroupAndType, setDwgTypeGroupAndType] = useState(null);
  const [dwgType, setDwgType] = useState(null);
  const [unpublishDetailProperty, setUnpublishDetailProperty] = useState(null);
  const [dwgTypeGroupSelected, setDwgTypeGroupSelected] = useState("");
  const [dwgTypeSelected, setDwgTypeSelected] = useState([]);
  const [dwgTagName, setDwgTagName] = useState("");
  const [webViewerProps, setWebViewerProps] = useState(null);
  const [coverButton, SetCoverButton] = useState("");
  const [selected, setSelected] = useState([]);
  const [validationErrors, setValidationErrors] = useState([]);
  const [aiCoverSelected, setAiCoverSelected] = useState([]);
  const [bdCoverSelected, setBdCoverSelected] = useState([]);
  const [fileContent, setFileContent] = useState();
  const [lockScreenLoadingOpen, setLockScreenLoadingOpen] = useState(false);
  const [lockScreenProgressTitle, setLockScreenProgressTitle] = useState("");

  // Dialog State
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertData, setAlertData] = useState({
    type: "",
    title: "",
    content: "",
  });

  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [confirmDialogData, setConfirmDialogData] = useState({
    dialogTitle: "",
    dialogContent: "",
    confirmAction: "",
    cancelAction: "",
  });

  // Build Alert
  const buildAlert = (data) => {
    setAlertData({
      type: data.type,
      title: data.title,
      content: data.content,
    });
    setAlertOpen(true);
  };

  // Build Confirm Dialog
  const confirmDialogHandleOpen = (data) => {
    setConfirmDialogData({
      dialogTitle: data.dialogTitle,
      dialogContent: data.dialogContent,
      confirmAction: data.confirmAction,
      cancelAction: data.cancelAction,
    });

    setConfirmDialogOpen(true);
  };

  const confirmDialogHandleClose = () => {
    setConfirmDialogOpen(false);
  };

  // Input Handle
  const handleCheckDrawingPanel = (index) => (event) => {
    const { checked } = event.target;
    const res = { ...unpublishDetailProperty };
    let filtered;

    res.files[index].is_selected = checked;

    if (checked) {
      setSelected([...selected, index]);
    } else {
      filtered = selected.filter((value) => {
        return value !== index;
      });

      setSelected(filtered);
      setValidationErrors([]);
    }

    setUnpublishDetailProperty(res);
    dispatch({
      type: "ADD_UNPUBLISH_DETAIL",
      data: res,
    });

    validate(filtered);
  };

  const handleChangePurpose = (index) => (event, newPurpose) => {
    const res = { ...unpublishDetailProperty };
    res.files[index].attrs.dwg_purposes = newPurpose;

    setUnpublishDetailProperty(res);
    dispatch({
      type: "ADD_UNPUBLISH_DETAIL",
      data: res,
    });
  };

  const handleToggleCheckedPublishType = (index) => (event) => {
    const { id, checked } = event.target;
    const res = { ...unpublishDetailProperty };
    let filtered;

    if (id === "AI_COVER") {
      if (checked) {
        filtered = bdCoverSelected.filter((value) => {
          return value !== index;
        });

        setAiCoverSelected([...aiCoverSelected, index]);
        setBdCoverSelected(filtered);
      } else {
        filtered = aiCoverSelected.filter((value) => {
          return value !== index;
        });

        setAiCoverSelected(filtered);
      }
    } else if (id === "BD_COVER") {
      if (checked) {
        filtered = aiCoverSelected.filter((value) => {
          return value !== index;
        });

        setBdCoverSelected([...bdCoverSelected, index]);
        setAiCoverSelected(filtered);
      } else {
        filtered = bdCoverSelected.filter((value) => {
          return value !== index;
        });

        setBdCoverSelected(filtered);
      }
    } else if (id === "REMOVE") {
      setAiCoverSelected([]);
      setBdCoverSelected([]);
    }

    res.files[index].attrs.publish_type = checked ? id : "DRAWING";

    setUnpublishDetailProperty(res);
    dispatch({
      type: "ADD_UNPUBLISH_DETAIL",
      data: res,
    });
  };

  const handleTextChange = (index) => (event) => {
    const { name, value } = event.target;
    const res = { ...unpublishDetailProperty };
    res.files[index].attrs[name] = value;

    setUnpublishDetailProperty(res);
    dispatch({
      type: "ADD_UNPUBLISH_DETAIL",
      data: res,
    });

    // validate(res)
  };

  const handleChangeDwgTypeGroup = (index) => (event) => {
    const { value } = event.target;
    const res = { ...unpublishDetailProperty };

    res.files[index].attrs.dwg_type_group = value;
    res.files[index].attrs.dwg_types = [];
    res.files[index].attrs.dwg_type_names = [];

    setDwgTypeGroupSelected(value);
    setDwgTypeSelected([]);
    setDwgType(null);

    setUnpublishDetailProperty(res);
    dispatch({
      type: "ADD_UNPUBLISH_DETAIL",
      data: res,
    });

    dwgTypeGroupAndType.map((res) => {
      if (res.type_group_seq === event.target.value) {
        setDwgType(res.types);
      }
    });
  };

  const handleChangeDwgType = (index) => (event, child) => {
    const { id } = child.props;
    const { value } = event.target;
    const res = { ...unpublishDetailProperty };
    const newSelected = [];

    value.map((selectedTypeName) => {
      dwgType.map((res) => {
        if (res.type_name === selectedTypeName) {
          newSelected.push(res.type_seq);
        }
      });
    });

    setDwgTypeSelected(newSelected);

    res.files[index].attrs.dwg_types = newSelected;
    res.files[index].attrs.dwg_type_names = value;

    setUnpublishDetailProperty(res);
    dispatch({
      type: "ADD_UNPUBLISH_DETAIL",
      data: res,
    });
  };

  const handleTextChangeDwgTag = (event) => {
    const { value } = event.target;
    setDwgTagName(value);
  };

  const handleAddTags = (index) => (event) => {
    if (dwgTagName !== "") {
      if (event.key === "Enter" || typeof event.key === "undefined") {
        const res = { ...unpublishDetailProperty };
        const newTag = res.files[index].attrs.dwg_tags;

        newTag.push(dwgTagName);
        res.files[index].attrs.dwg_tags = newTag;

        setDwgTagName("");

        setUnpublishDetailProperty(res);
        dispatch({
          type: "ADD_UNPUBLISH_DETAIL",
          data: res,
        });
      }
    }
  };

  const handleTagDelete = (index, tagName) => () => {
    const res = { ...unpublishDetailProperty };
    const newTags = res.files[index].attrs.dwg_tags.filter(
      (deleteItem) => deleteItem !== tagName
    );

    res.files[index].attrs.dwg_tags = newTags;

    setUnpublishDetailProperty(res);
    dispatch({
      type: "ADD_UNPUBLISH_DETAIL",
      data: res,
    });
  };

  const applyAllConfirmAction = (index) => () => {
    confirmDialogHandleOpen({
      dialogTitle: "Drawing Register",
      dialogContent:
        "Do you want to apply the content to all drawing. This action will be overwrite original content.",
      confirmAction: handleApplyAll(index),
      cancelAction: applyAllCancelAction,
    });
  };

  const applyAllCancelAction = () => {
    confirmDialogHandleClose();
  };

  const applySelectedConfirmAction = (index) => () => {
    if (selected.length === 0) {
      buildAlert({
        // Alert Type: success, info, warning, error
        type: "warning",
        title: "Warning Alert",
        content: "Please choose the drawing to apply the content.",
      });
    } else {
      confirmDialogHandleOpen({
        dialogTitle: "Drawing Register",
        dialogContent:
          "Do you want to apply the field content to selected drawing. This action will be overwrite original field content.",
        confirmAction: handleApplySelected(index),
        cancelAction: applySelectedCancelAction,
      });
    }
  };

  const applySelectedCancelAction = () => {
    confirmDialogHandleClose();
  };

  const handleApplyAll = (index) => () => {
    confirmDialogHandleClose();

    setLockScreenProgressTitle("Processing...");
    setLockScreenLoadingOpen(true);

    const sourceData = unpublishDetailProperty.files[index].attrs;
    const result = { ...unpublishDetailProperty };

    result.files.map((res) => {
      res.attrs.dwg_purposes = sourceData.dwg_purposes;
      res.attrs.dwg_no = sourceData.dwg_no;
      res.attrs.rev_no = sourceData.rev_no;
      res.attrs.dwg_title = sourceData.dwg_title;
      res.attrs.dwg_type_group = sourceData.dwg_type_group;
      res.attrs.dwg_type_names = sourceData.dwg_type_names;
      res.attrs.dwg_types = sourceData.dwg_types;
      res.attrs.dwg_tags = sourceData.dwg_tags;
    });

    setUnpublishDetailProperty(result);
    dispatch({
      type: "ADD_UNPUBLISH_DETAIL",
      data: result,
    });

    setLockScreenLoadingOpen(false);
  };

  const handleApplySelected = (index) => () => {
    confirmDialogHandleClose();

    setLockScreenProgressTitle("Processing...");
    setLockScreenLoadingOpen(true);

    const sourceData = unpublishDetailProperty.files[index].attrs;
    const result = { ...unpublishDetailProperty };

    result.files.map((res) => {
      if (res.is_selected) {
        res.attrs.dwg_purposes = sourceData.dwg_purposes;
        res.attrs.dwg_no = sourceData.dwg_no;
        res.attrs.rev_no = sourceData.rev_no;
        res.attrs.dwg_title = sourceData.dwg_title;
        res.attrs.dwg_type_group = sourceData.dwg_type_group;
        res.attrs.dwg_type_names = sourceData.dwg_type_names;
        res.attrs.dwg_types = sourceData.dwg_types;
        res.attrs.dwg_tags = sourceData.dwg_tags;
      }
    });

    setUnpublishDetailProperty(result);
    dispatch({
      type: "ADD_UNPUBLISH_DETAIL",
      data: result,
    });

    setLockScreenLoadingOpen(false);
  };

  const handleChangeCover = (coverType) => () => {
    SetCoverButton(coverType);
  };

  const handleChangeDrawingPanel =
    (index, panel, fileCat, fileRef, fileName) => (event, isExpanded) => {
      setDwgType(null);
      setExpanded(isExpanded ? panel : false);

      if (isExpanded) {
        dwgTypeGroupAndType.map((res) => {
          if (
            unpublishDetailProperty.files[index].attrs.dwg_type_group ===
            res.type_group_seq
          ) {
            setDwgType(res.types);
          }
        });

        setWebViewerProps({
          from: "API",
          autoLoading: false,
          file_cat: fileCat,
          file_ref: fileRef,
          file_name: fileName,
        });
      }
    };
  const s2ab = (s) => {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i < s.length; i++) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  };
  const downloadExcel = () => {
    let fileIndexes = unpublishDetailProperty.files.map((obj, index) => {
      return { unpublish_file_seq: obj.unpublish_file_seq, index: index + 1 };
    });
    let workbook = XLSX.utils.book_new();
    workbook.SheetNames.push("Sheet1");
    workbook.SheetNames.push("DWG Type Group Mapping List");

    let ws_data = [
      [
        "",
        "Drawing Index",
        "Publish Type( DRAWING/REMOVE/AI_COVER/BD_COVER)",
        "Construction(Y/N)",
        "Information(Y/N)",
        "Procurement(Y/N)",
        "Tender(Y/N)",
        "Drawing No.",
        "Revision No.",
        "Drawing Title",
        "DWG Type Group(Refer to DWG Type Group Mapping List)",
        "DWG Type(Refer to DWG Type Group Mapping List) (Add ; after one type.For example: GBP;Layout)",
        "Drawing Tag (Add ; after one tag.For example: DrawA;DrawB)",
      ],
      [
        "unpublish_file_seq",
        "index",
        "publish_type",
        "Construction" /* dwg_purpose 1:Constuction, 2:Information, 3:Procurement, 4: Tender */,
        "Information" /* dwg_purpose 1:Constuction, 2:Information, 3:Procurement, 4: Tender */,
        "Procurement" /* dwg_purpose 1:Constuction, 2:Information, 3:Procurement, 4: Tender */,
        "Tender" /* dwg_purpose 1:Constuction, 2:Information, 3:Procurement, 4: Tender */,
        "dwg_no",
        "rev_no",
        "dwg_title",
        "dwg_type_group",
        "dwg_type_names",
        "dwg_tags",
      ],
    ];
    let ws_data2 = [["Type Group:"]];
    ws_data2.push(["type_group_seq", "type_seq", "DWG Type Group", "DWG Type"]);
    for (const dwgGroup of dwgTypeGroupAndType) {
      for (const type of dwgGroup.types) {
        ws_data2.push([
          dwgGroup.type_group_seq,
          type.type_seq,
          dwgGroup.type_group_name,
          type.type_name,
        ]);
      }
    }

    for (let i = 0; i < fileIndexes.length; i++) {
      ws_data.push([
        fileIndexes[i]["unpublish_file_seq"],
        fileIndexes[i]["index"],
      ]);
    }

    let wscols = [
      { hidden: true },
      { width: 20 }, // first column
      { width: 55 }, // second column
      { width: 20 }, //...
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 85 },
      { width: 105 },
      { width: 65 },
    ];

    let wscols2 = [
      { hidden: true },
      { hidden: true },
      { width: 45 },
      { width: 45 },
    ];

    let wsrows = [
      { hpt: 20 }, // height for row 1
      { hidden: true }, //height for row 2
    ];

    let ws = XLSX.utils.aoa_to_sheet(ws_data);
    let ws2 = XLSX.utils.aoa_to_sheet(ws_data2);
    workbook.Sheets["Sheet1"] = ws;
    workbook.Sheets["DWG Type Group Mapping List"] = ws2;
    ws["!cols"] = wscols;
    ws2["!cols"] = wscols2;
    ws["!rows"] = wsrows;
    let excel = XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    FileSaver.saveAs(
      new Blob([s2ab(excel)], { type: "application/octet-system" }),
      `${unpublishDetailProperty.cover.ai_cover_no}.xlsx`
    );
  };

  const excelReader = async (file) => {
    new Promise((resolve, reject) => {
      dispatch({
        type: "ADD_IMPORT_FILE",
        data: null,
      });
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);
      fileReader.onload = (event) => {
        try {
          const bufferArray = event.target.result;
          const wb = XLSX.read(bufferArray, { type: "buffer" });
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];

          /* skip the first row */
          var range = XLSX.utils.decode_range(ws["!ref"]);
          range.s.r = 1; // <-- zero-indexed, so setting to 1 will skip row 0
          ws["!ref"] = XLSX.utils.encode_range(range);

          // const data = XLSX.utils.sheet_to_json(ws)
          const datas = XLSX.utils.sheet_to_json(ws, { defval: "" });

          let fileData = datas;
          for (const data of fileData) {
            let purpose = [];
            if (data.Construction.toUpperCase() === "Y") {
              purpose = [...purpose, 1];
            }
            if (data.Information.toUpperCase() === "Y") {
              purpose = [...purpose, 2];
            }
            if (data.Procurement.toUpperCase() === "Y") {
              purpose = [...purpose, 3];
            }
            if (data.Tender.toUpperCase() === "Y") {
              purpose = [...purpose, 4];
            }
            data.dwg_purposes = purpose;
            data.dwg_tags = data.dwg_tags
              .split(";")
              .filter((obj) => obj !== "");
            data.dwg_type_names = data.dwg_type_names
              .split(";")
              .filter((obj) => obj !== "");
            data.dwg_type_group =
              dwgTypeGroupAndType.filter(
                (obj) =>
                  obj.type_group_name.replace(/\s/g, "").toUpperCase() ===
                  data.dwg_type_group.replace(/\s/g, "").toUpperCase()
              )[0]?.type_group_seq === undefined
                ? -1
                : dwgTypeGroupAndType.filter(
                    (obj) =>
                      obj.type_group_name.replace(/\s/g, "").toUpperCase() ===
                      data.dwg_type_group.replace(/\s/g, "").toUpperCase()
                  )[0]?.type_group_seq;
            let type_seq_array = [];
            for (const dwgType of data.dwg_type_names) {
              if (data.dwg_type_group !== -1) {
                let type_name =
                  dwgTypeGroupAndType
                    .filter(
                      (obj) => obj.type_group_seq === data.dwg_type_group
                    )[0]
                    .types.filter(
                      (obj) =>
                        obj.type_name.replace(/\s/g, "").toUpperCase() ===
                        dwgType.replace(/\s/g, "").toUpperCase()
                    )[0]?.type_name === undefined
                    ? ""
                    : dwgTypeGroupAndType
                        .filter(
                          (obj) => obj.type_group_seq === data.dwg_type_group
                        )[0]
                        .types.filter(
                          (obj) =>
                            obj.type_name.replace(/\s/g, "").toUpperCase() ===
                            dwgType.replace(/\s/g, "").toUpperCase()
                        )[0]?.type_name;
                type_seq_array = [...type_seq_array, type_name];
              }
            }
            data.dwg_type_names = type_seq_array.filter((obj) => obj !== "");
            let updateData = { ...unpublishDetailProperty };
            let fileIndex = unpublishDetailProperty.files.findIndex(
              (obj) => obj.unpublish_file_seq === data.unpublish_file_seq
            );
            if (fileIndex === -1) {
              throw new Error();
            }

            if (
              data.publish_type.replace(/\s/g, "").toUpperCase() ===
                "AI_COVER".replace(/\s/g, "") ||
              data.publish_type.replace(/\s/g, "").toUpperCase() ===
                "REMOVE".replace(/\s/g, "") ||
              data.publish_type.replace(/\s/g, "").toUpperCase() ===
                "BD_COVER".replace(/\s/g, "")
            ) {
              updateData["files"][fileIndex]["attrs"]["publish_type"] =
                data.publish_type;
            } else if (
              data.publish_type.replace(/\s/g, "").toUpperCase() === "DRAWING"
            ) {
              updateData["files"][fileIndex]["attrs"]["publish_type"] =
                data.publish_type;
              updateData["files"][fileIndex]["attrs"]["dwg_purposes"] =
                data.dwg_purposes;
              updateData["files"][fileIndex]["attrs"]["rev_no"] = data.rev_no;
              updateData["files"][fileIndex]["attrs"]["dwg_no"] = data.dwg_no;
              updateData["files"][fileIndex]["attrs"]["dwg_title"] =
                data.dwg_title;
              updateData["files"][fileIndex]["attrs"]["dwg_tags"] =
                data.dwg_tags;
              updateData["files"][fileIndex]["attrs"]["dwg_type_group"] =
                data.dwg_type_group;
              updateData["files"][fileIndex]["attrs"]["dwg_type_names"] =
                data.dwg_type_names;
            }
          }
          dispatch({
            type: "ADD_UNPUBLISH_DETAIL",
            data: datas,
          });
          resolve(datas);
          buildAlert({
            // Alert Type: success, info, warning, error
            type: "success",
            title: "Success Alert",
            content: "The Excel has been imported successfully",
          });
        } catch (err) {
          dispatch({
            type: "ADD_IMPORT_FILE",
            data: null,
          });
          buildAlert({
            // Alert Type: success, info, warning, error
            type: "error",
            title: "Error Alert",
            content:
              "Something went wrong, please make sure the excel is the one downloaded from the template",
          });
        } finally {
          setLockScreenLoadingOpen(false);
        }
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const readFileAction = (acceptedFiles) => {
    setLockScreenProgressTitle("Loading...");
    setLockScreenLoadingOpen(true);
    dispatch({
      type: "ADD_IMPORT_FILE",
      data: acceptedFiles[0],
    });

    excelReader(acceptedFiles[0]);
  };
  const rejectedFileAction = (rejectedFiles) => {
    buildAlert({
      // Alert Type: success, info, warning, error
      type: "error",
      title: "Error Alert",
      content:
        rejectedFiles[0].errors[0].code +
        " > " +
        rejectedFiles[0].errors[0].message,
    });
  };

  const handleSelectAllDrawing = () => {
    const tempUnpublishDetailProperty = { ...unpublishDetailProperty };
    const tempSelected = [];

    tempUnpublishDetailProperty.files.map((res, index) => {
      tempSelected.push(index);

      if (res.attrs.publish_type !== "REMOVE") {
        res.is_selected = true;
      }
    });

    setSelected(tempSelected);
    setUnpublishDetailProperty(tempUnpublishDetailProperty);
    dispatch({
      type: "ADD_UNPUBLISH_DETAIL",
      data: tempUnpublishDetailProperty,
    });
  };

  const handleUnselectAllDrawing = () => {
    const tempUnpublishDetailProperty = { ...unpublishDetailProperty };

    tempUnpublishDetailProperty.files.map((res) => {
      if (res.attrs.publish_type !== "REMOVE") {
        res.is_selected = false;
      }
    });

    setSelected([]);
    setValidationErrors([]);
    setUnpublishDetailProperty(tempUnpublishDetailProperty);
    dispatch({
      type: "ADD_UNPUBLISH_DETAIL",
      data: tempUnpublishDetailProperty,
    });
  };

  const unpublishSaveDraftConfirmAction = () => {
    // if (validate()) {
    confirmDialogHandleOpen({
      dialogTitle: "Drawing Register",
      dialogContent: "Do you want to save the drawing.",
      confirmAction: unpublishSaveDraftAction,
      cancelAction: unpublishSaveDraftCancelAction,
    });
    // }
  };

  const unpublishSaveDraftAction = () => {
    saveUnpublish(
      unpublishDetailProperty.unpublish_seq,
      unpublishDetailProperty
    ).then((res) => {
      console.log(
        "*****************************************************************************"
      );
      console.log("System Module: Drawing Register");
      console.log("Message: The draft of drawing save successful.");
      console.log(res);
      console.log(
        "*****************************************************************************"
      );

      unpublishSaveDraftCancelAction();

      buildAlert({
        // Alert Type: success, info, warning, error
        type: "success",
        title: "Success Alert",
        content: "The draft of drawing have been save",
      });
    });
  };

  const unpublishSaveDraftCancelAction = () => {
    confirmDialogHandleClose();
  };

  const closeDrawingSetConfirmAction = () => {
    confirmDialogHandleOpen({
      dialogTitle: "Drawing Register",
      dialogContent: "Do you want to close this un-publish record set.",
      confirmAction: closeDrawingSetAction,
      cancelAction: closeDrawingSetCancelAction,
    });
  };

  const closeDrawingSetAction = () => {
    closeDrawingSetCancelAction();

    deleteUnpublish(unpublishDetailProperty.unpublish_seq).then((res) => {
      buildAlert({
        // Alert Type: success, info, warning, error
        type: "success",
        title: "Success Alert",
        content: "The unpublish set have been closed",
      });

      setTimeout(() => {
        setRefashUnpublishRecord(res.code);
        closeUnpublishDetail();
      }, 1000);
    });
  };

  const closeDrawingSetCancelAction = () => {
    confirmDialogHandleClose();
  };

  // const publishDrawingConfirmAction = () => {
  // 	if (selected.length === 0) {
  // 		buildAlert({
  // 			// Alert Type: success, info, warning, error
  // 			type: "warning",
  // 			title: "Warning Alert",
  // 			content: "Please choose the drawing to publish."
  // 		})
  // 	}
  // 	else if (!validate(selected)) {
  // 		buildAlert({
  // 			// Alert Type: success, info, warning, error
  // 			type: "warning",
  // 			title: "Warning Alert",
  // 			content: "Some required field not fill."
  // 		})

  // 		return
  // 	}
  // 	else {
  // 		if (unpublishDetailProperty.required.ai_cover) {
  // 			if (aiCoverSelected.length === 0) {
  // 				buildAlert({
  // 					// Alert Type: success, info, warning, error
  // 					type: "warning",
  // 					title: "Warning Alert",
  // 					content: "AI Cover still no publish, this publish must include the AI Cover."
  // 				})

  // 				return
  // 			}
  // 		}

  // 		if (unpublishDetailProperty.required.bd_cover) {
  // 			if (bdCoverSelected.length === 0) {
  // 				buildAlert({
  // 					// Alert Type: success, info, warning, error
  // 					type: "warning",
  // 					title: "Warning Alert",
  // 					content: "BD Cover still no publish, this publish must include the BD Cover."
  // 				})

  // 				return
  // 			}
  // 		}

  // 		confirmDialogHandleOpen({
  // 			dialogTitle: "Drawing Register",
  // 			dialogContent: "Do you want to publish the selected drawing.",
  // 			confirmAction: publishDrawingAction,
  // 			cancelAction: publishDrawingCancelAction
  // 		})
  // 	}

  // }

  const publishDrawingConfirmAction = () => {
    if (selected.length === 0) {
      buildAlert({
        // Alert Type: success, info, warning, error
        type: "warning",
        title: "Warning Alert",
        content: "Please choose the drawing to publish.",
      });
    } else {
      if (unpublishDetailProperty.required.ai_cover) {
        if (
          !unpublishDetailProperty.files.some(
            (item, index) =>
              item.attrs.publish_type === "AI_COVER" &&
              unpublishDetailProperty.files[index].is_selected
          )
        ) {
          buildAlert({
            // Alert Type: success, info, warning, error
            type: "warning",
            title: "Warning Alert",
            content:
              "AI Cover still no publish, this publish must include the AI Cover.",
          });

          return;
        }
      }

      if (unpublishDetailProperty.required.bd_cover) {
        if (
          !unpublishDetailProperty.files.some(
            (item, index) =>
              item.attrs.publish_type === "BD_COVER" &&
              unpublishDetailProperty.files[index].is_selected
          )
        ) {
          buildAlert({
            // Alert Type: success, info, warning, error
            type: "warning",
            title: "Warning Alert",
            content:
              "BD Cover still no publish, this publish must include the AI Cover.",
          });

          return;
        }
      }

      if (!validate(selected)) {
        buildAlert({
          // Alert Type: success, info, warning, error
          type: "warning",
          title: "Warning Alert",
          content: "Some required field not fill.",
        });

        return;
      }

      confirmDialogHandleOpen({
        dialogTitle: "Drawing Register",
        dialogContent: "Do you want to publish the selected drawing.",
        confirmAction: publishDrawingAction,
        cancelAction: publishDrawingCancelAction,
      });
    }
  };

  const publishDrawingAction = () => {
    setLockScreenProgressTitle("Publishing...");
    setLockScreenLoadingOpen(true);

    publishDrawing(
      unpublishDetailProperty.unpublish_seq,
      unpublishDetailProperty
    ).then((res) => {
      publishDrawingCancelAction();

      console.log(
        "*****************************************************************************"
      );
      console.log("System Module: Drawing Register");
      console.log("Message: The drawing have been published.");
      console.log(res);
      console.log(
        "*****************************************************************************"
      );

      buildAlert({
        // Alert Type: success, info, warning, error
        type: "success",
        title: "Success Alert",
        content: "The drawing have been published",
      });

      setTimeout(() => {
        setRefashUnpublishRecord(res.code);
        closeUnpublishDetail();

        setLockScreenLoadingOpen(true);
        setLockScreenProgressTitle("");
      }, 1000);
    });
  };

  const publishDrawingCancelAction = () => {
    confirmDialogHandleClose();
  };

  // Input Validation
  const validate = (selected, fieldValues = unpublishDetailProperty.files) => {
    // let errorMsg = [...validationErrors]
    let errorMsg = [];

    if (selected) {
      selected.map((index) => {
        const tempMsg = {};

        if (fieldValues[index].attrs.publish_type === "DRAWING") {
          if ("dwg_purposes" in fieldValues[index].attrs) {
            if (fieldValues[index].attrs.dwg_purposes.length === 0) {
              tempMsg.dwg_purposes = "This field is required";
            }
          }

          if ("dwg_no" in fieldValues[index].attrs) {
            if (!fieldValues[index].attrs.dwg_no) {
              tempMsg.dwg_no = "This field is required";
            }
          }

          if ("rev_no" in fieldValues[index].attrs) {
            if (!fieldValues[index].attrs.rev_no) {
              tempMsg.rev_no = "This field is required";
            }
          }

          if ("dwg_title" in fieldValues[index].attrs) {
            if (!fieldValues[index].attrs.dwg_title) {
              tempMsg.dwg_title = "This field is required";
            }
          }

          if ("dwg_type_group" in fieldValues[index].attrs) {
            if (fieldValues[index].attrs.dwg_type_group === -1) {
              tempMsg.dwg_type_group = "This field is required";
            }
          }

          if ("dwg_types" in fieldValues[index].attrs) {
            if (fieldValues[index].attrs.dwg_types.length === 0) {
              tempMsg.dwg_types = "This field is required";
            }
          }
        }

        if (Object.keys(tempMsg).length > 0) {
          errorMsg[index] = tempMsg;
        }
      });

      setValidationErrors([...errorMsg]);

      if (fieldValues == unpublishDetailProperty.files) {
        return Object.values(errorMsg).every((x) => {
          if (x && typeof x !== "undefined") {
            Object.values(x).every((y) => y == "");
          }
        });
      }
    }
  };

  useEffect(() => {
    getUnpublishDetailShowLoading();

    getPurposeType().then((res) => {
      setPurposeType(res);
    });

    getDrawingTypeAndGroup().then((res) => {
      setDwgTypeGroupAndType(res);
    });

    getUnpublishDetail(unpublishSeq).then((res) => {
      SetCoverButton(
        res.data[0].cover_type.contain_ai
          ? "AI"
          : res.data[0].cover_type.contain_bd
          ? "BD"
          : "NIL"
      );

      setUnpublishDetailProperty(res.data[0]);
      dispatch({
        type: "ADD_UNPUBLISH_DETAIL",
        data: res.data[0],
      });

      getUnpublishDetailHiddenLoading();
    });
  }, []);

  return (
    // console.log("Purpose Type | Variable: dwgTypeGroupAndType (unpublishDetail.js)"),
    // console.log(dwgTypeGroupAndType),

    // console.log("Drawing Type | Variable: dwgType (unpublishDetail.js)"),
    // console.log(dwgType),

    console.log(
      "Unpublish Detail Record | Variable: unpublishDetailProperty (unpublishDetail.js)"
    ),
    console.log(unpublishDetailProperty),
    // console.log("AI Cover Selected | Variable: aiCoverSelected (unpublishDetail.js)"),
    // console.log(aiCoverSelected),

    // console.log("BD Cover Selected | Variable: bdCoverSelected (unpublishDetail.js)"),
    // console.log(bdCoverSelected),

    // console.log("Unpublish Record Selected | Variable: selected (unpublishDetail.js)"),
    // console.log(selected),

    console.log(
      "Unpublish Validation Errors | Variable: validationErrors (unpublishDetail.js)"
    ),
    console.log(validationErrors),
    console.log(
      "---------------------------------------------------------------------------------"
    ),
    (
      <Fragment>
        <div>
          <LockScreenLoading
            open={lockScreenLoadingOpen}
            circleSize={200}
            progressTitle={lockScreenProgressTitle}
          />

          <Alert
            open={alertOpen}
            alertType={alertData.type}
            alertTitle={alertData.title}
            alertContent={alertData.content}
            handleClose={() => setAlertOpen(false)}
          />

          <ConfirmDialog
            open={confirmDialogOpen}
            dialogTitle={confirmDialogData.dialogTitle}
            dialogContent={confirmDialogData.dialogContent}
            confirmAction={confirmDialogData.confirmAction}
            cancelAction={confirmDialogData.cancelAction}
          />

          {/* <FullScreenDialog
					open={unpublishDetailDialogOpen}
					dialogTitle={"Un-Publish Detail"}

					formContent={
						// <DrawingDetail
						// 	drawingDetailRecord={drawingDetailRecord}
						// />
						<div>Detail</div>
					}

					button={unpublishDialogBtn}
					handleClose={unpublishDetailDialogHandleClose}
				/> */}
        </div>

        <div>
          {getUnpublishDetailLoading}
          {unpublishDetailProperty ? (
            <div>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={6} lg={4}>
                  <Paper variant="outlined" className={classes.coverInfo}>
                    <div className={classes.coverInfoRow}>
                      <ButtonGroup
                        aria-label="cover-type-button-group"
                        color="primary"
                        size="small"
                      >
                        <Button
                          disabled={
                            !unpublishDetailProperty.cover_type.contain_ai
                          }
                          onClick={handleChangeCover("AI")}
                        >
                          AI Cover
                        </Button>
                        <Button
                          disabled={
                            !unpublishDetailProperty.cover_type.contain_bd
                          }
                          onClick={handleChangeCover("BD")}
                        >
                          BD Cover
                        </Button>
                      </ButtonGroup>
                    </div>

                    {coverButton === "AI" ? (
                      <div>
                        <div className={classes.coverInfoRow}>
                          <Typography
                            color="textPrimary"
                            className={classes.coverField}
                          >
                            AI Cover Number:{" "}
                          </Typography>
                          <Typography
                            color="textSecondary"
                            className={classes.coverContent}
                          >
                            {unpublishDetailProperty.cover.ai_cover_no}
                          </Typography>
                        </div>

                        <div className={classes.coverInfoRow}>
                          <Typography
                            color="textPrimary"
                            className={classes.coverField}
                          >
                            AI Cover Subject:{" "}
                          </Typography>
                          <Typography
                            color="textSecondary"
                            className={classes.coverContent}
                          >
                            {unpublishDetailProperty.cover.ai_cover_subject}
                          </Typography>
                        </div>

                        <div className={classes.coverInfoRow}>
                          <Typography
                            color="textPrimary"
                            className={classes.coverField}
                          >
                            Date of issue:{" "}
                          </Typography>
                          <Typography
                            color="textSecondary"
                            className={classes.coverContent}
                          >
                            {unpublishDetailProperty.cover.ai_issue_date}
                          </Typography>
                        </div>
                      </div>
                    ) : coverButton === "BD" ? (
                      <div>
                        <div className={classes.coverInfoRow}>
                          <Typography
                            color="textPrimary"
                            className={classes.coverField}
                          >
                            BD Cover Number:{" "}
                          </Typography>
                          <Typography
                            color="textSecondary"
                            className={classes.coverContent}
                          >
                            {unpublishDetailProperty.cover.bd_cover_no}
                          </Typography>
                        </div>

                        <div className={classes.coverInfoRow}>
                          <Typography
                            color="textPrimary"
                            className={classes.coverField}
                          >
                            BD Cover Subject:{" "}
                          </Typography>
                          <Typography
                            color="textSecondary"
                            className={classes.coverContent}
                          >
                            {unpublishDetailProperty.cover.bd_cover_subject}
                          </Typography>
                        </div>

                        <div className={classes.coverInfoRow}>
                          <Typography
                            color="textPrimary"
                            className={classes.coverField}
                          >
                            Date of issue:{" "}
                          </Typography>
                          <Typography
                            color="textSecondary"
                            className={classes.coverContent}
                          >
                            {unpublishDetailProperty.cover.bd_issue_date}
                          </Typography>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </Paper>

                  <Grid container className={classes.toolMenu}>
                    <Grid item className={classes.toolMenuBtnGroup}>
                      <Grid
                        container
                        spacing={1}
                        className={classes.toolMenuBtn}
                      >
                        <Grid item>
                          <Tooltip title="Select All Drawing">
                            <Fab
                              aria-label="select_all_drawing"
                              color="primary"
                              size="small"
                              onClick={handleSelectAllDrawing}
                              className={classes.selectAllDrawingBtn}
                            >
                              <CheckBoxIcon />
                            </Fab>
                          </Tooltip>
                        </Grid>

                        <Grid item>
                          <Tooltip title="Un-select All Drawing">
                            <Fab
                              color="primary"
                              size="small"
                              onClick={handleUnselectAllDrawing}
                              className={classes.selectAllDrawingBtn}
                            >
                              <CheckBoxOutlineBlankIcon />
                            </Fab>
                          </Tooltip>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item className={classes.toolMenuBtnGroup}>
                      <Grid
                        container
                        spacing={1}
                        className={classes.toolMenuBtn}
                      >
                        <Grid item>
                          <Tooltip title="Close this Drawing Set">
                            <Fab
                              color="primary"
                              size="small"
                              onClick={closeDrawingSetConfirmAction}
                              className={classes.toolMenuBarBtn}
                            >
                              <CloseIcon />
                            </Fab>
                          </Tooltip>
                        </Grid>

                        {/* <Grid item>
													<Tooltip title="OCR">
														<Fab 
															color="primary"
															size="small"
															//onClick={handleAddTags(index)}
															disabled
															className={classes.toolMenuBarBtn}
														>
															<ScannerIcon />
														</Fab>
													</Tooltip>
												</Grid> */}

                        <Grid item>
                          <Tooltip title="Publish Selected Drawing">
                            <Fab
                              color="primary"
                              size="small"
                              onClick={publishDrawingConfirmAction}
                              className={classes.toolMenuBarBtn}
                            >
                              <LibraryAddCheckIcon />
                            </Fab>
                          </Tooltip>
                        </Grid>

                        <Grid item>
                          <Tooltip title="Save">
                            <Fab
                              color="primary"
                              size="small"
                              onClick={unpublishSaveDraftConfirmAction}
                              className={classes.toolMenuBarBtn}
                            >
                              <SaveIcon />
                            </Fab>
                          </Tooltip>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Legend
                        label="Only Accept Excel Template File Downloaded for the Drawing"
                        required={true}
                      >
                        <DrawingFileDropZone
                          acceptFileType={[
                            "application/vnd.ms-excel",
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                          ]}
                          maxFiles={1}
                          exportExcel={downloadExcel}
                          DropzoneContent={DataImportDropzoneContent}
                          onAcceptedAction={readFileAction}
                          onRejectedAction={rejectedFileAction}
                        />
                      </Legend>
                    </Grid>
                  </Grid>

                  <div className={classes.drawingList}>
                    <MuiThemeProvider theme={drawingPanelTheme}>
                      {unpublishDetailProperty.files.map(
                        (drawingRes, index) => {
                          return (
                            <Accordion
                              key={index}
                              expanded={expanded === "panel" + index}
                              onChange={handleChangeDrawingPanel(
                                index,
                                "panel" + index,
                                drawingRes.file_cat,
                                drawingRes.unpublish_file_seq,
                                drawingRes.unpublish_file_seq +
                                  "_page_" +
                                  (index + 1) +
                                  ".pdf"
                              )}
                            >
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-label="Expand"
                                aria-controls="additional-actions1-content"
                                id="additional-actions1-header"

                                // className={classes.AccordionFocus}
                              >
                                <FormControlLabel
                                  aria-label="Acknowledge"
                                  onClick={(event) => event.stopPropagation()}
                                  onFocus={(event) => event.stopPropagation()}
                                  control={
                                    <Checkbox
                                      checked={drawingRes.is_selected}
                                      onChange={handleCheckDrawingPanel(index)}
                                      disabled={
                                        drawingRes.attrs.publish_type ===
                                        "REMOVE"
                                          ? true
                                          : false
                                      }
                                    />
                                  }
                                  label={index + 1}
                                />
                              </AccordionSummary>

                              <AccordionDetails>
                                {expanded === "panel" + index ? (
                                  <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} lg={4}>
                                      <FormGroup>
                                        <FormControlLabel
                                          control={
                                            <Switch
                                              id="REMOVE"
                                              color="primary"
                                              checked={
                                                drawingRes.attrs
                                                  .publish_type === "REMOVE"
                                                  ? true
                                                  : false
                                              }
                                              onChange={handleToggleCheckedPublishType(
                                                index
                                              )}
                                            />
                                          }
                                          label="REMOVE"
                                        />
                                      </FormGroup>
                                    </Grid>

                                    {unpublishDetailProperty ? (
                                      unpublishDetailProperty.cover_type
                                        .contain_ai ? (
                                        <Grid item xs={6} sm={6} lg={4}>
                                          <FormGroup>
                                            <FormControlLabel
                                              control={
                                                <Switch
                                                  id="AI_COVER"
                                                  color="primary"
                                                  checked={
                                                    drawingRes.attrs
                                                      .publish_type ===
                                                    "AI_COVER"
                                                      ? true
                                                      : false
                                                  }
                                                  disabled={
                                                    drawingRes.attrs
                                                      .publish_type === "REMOVE"
                                                      ? true
                                                      : false
                                                  }
                                                  onChange={handleToggleCheckedPublishType(
                                                    index
                                                  )}
                                                />
                                              }
                                              label="AI COVER"
                                            />
                                          </FormGroup>
                                        </Grid>
                                      ) : (
                                        ""
                                      )
                                    ) : (
                                      ""
                                    )}

                                    {unpublishDetailProperty ? (
                                      unpublishDetailProperty.cover_type
                                        .contain_bd ? (
                                        <Grid item xs={6} sm={6} lg={4}>
                                          <FormGroup>
                                            <FormControlLabel
                                              control={
                                                <Switch
                                                  id="BD_COVER"
                                                  color="primary"
                                                  checked={
                                                    drawingRes.attrs
                                                      .publish_type ===
                                                    "BD_COVER"
                                                      ? true
                                                      : false
                                                  }
                                                  disabled={
                                                    drawingRes.attrs
                                                      .publish_type === "REMOVE"
                                                      ? true
                                                      : false
                                                  }
                                                  onChange={handleToggleCheckedPublishType(
                                                    index
                                                  )}
                                                />
                                              }
                                              label="BD COVER"
                                            />
                                          </FormGroup>
                                        </Grid>
                                      ) : (
                                        ""
                                      )
                                    ) : (
                                      ""
                                    )}

                                    <Grid item xs={12} sm={12} lg={12}>
                                      <ToggleButtonGroup
                                        value={drawingRes.attrs.dwg_purposes}
                                        onChange={handleChangePurpose(index)}
                                        aria-label="dwg_purposes"
                                        className={classes.ToggleButtonGroup}
                                      >
                                        {purposeType
                                          ? purposeType.map((res) => {
                                              return (
                                                <ToggleButton
                                                  key={res.purpose_seq}
                                                  aria-label={res.purpose_name}
                                                  value={res.purpose_seq}
                                                  disabled={
                                                    drawingRes.attrs
                                                      .publish_type ===
                                                      "REMOVE" ||
                                                    drawingRes.attrs
                                                      .publish_type ===
                                                      "AI_COVER" ||
                                                    drawingRes.attrs
                                                      .publish_type ===
                                                      "BD_COVER"
                                                      ? true
                                                      : false
                                                  }
                                                  className={
                                                    classes.ToggleButton
                                                  }
                                                >
                                                  <PurposeTypography
                                                    style={{ color: res.color }}
                                                  >
                                                    {res.name}
                                                  </PurposeTypography>
                                                </ToggleButton>
                                              );
                                            })
                                          : ""}
                                      </ToggleButtonGroup>
                                      {
                                        // validationErrors.dwg_purposes && validationErrors.dwg_purposes !== "" ?
                                        typeof validationErrors[index] !==
                                          "undefined" &&
                                        validationErrors.length > 0 ? (
                                          validationErrors[index]
                                            .dwg_purposes &&
                                          validationErrors[index]
                                            .dwg_purposes !== "" ? (
                                            <ValidationErrorMsgTypography
                                              className={
                                                classes.validationErrorMsg
                                              }
                                            >
                                              {
                                                validationErrors[index]
                                                  .dwg_purposes
                                              }
                                            </ValidationErrorMsgTypography>
                                          ) : (
                                            ""
                                          )
                                        ) : (
                                          ""
                                        )
                                      }
                                    </Grid>

                                    <Grid item xs={12} sm={6} lg={6}>
                                      <TextField
                                        id={"dwg_no_" + index}
                                        name="dwg_no"
                                        label="Drawing No."
                                        required
                                        disabled={
                                          drawingRes.attrs.publish_type ===
                                            "REMOVE" ||
                                          drawingRes.attrs.publish_type ===
                                            "AI_COVER" ||
                                          drawingRes.attrs.publish_type ===
                                            "BD_COVER"
                                            ? true
                                            : false
                                        }
                                        fullWidth={true}
                                        size="small"
                                        variant="outlined"
                                        value={drawingRes.attrs.dwg_no}
                                        onChange={handleTextChange(index)}
                                        // InputLabelProps={{
                                        // 	shrink: true,
                                        // }}
                                        error={
                                          typeof validationErrors[index] !==
                                            "undefined" &&
                                          validationErrors.length > 0
                                            ? validationErrors[index].dwg_no &&
                                              validationErrors[index].dwg_no !==
                                                ""
                                              ? true
                                              : false
                                            : false
                                        }
                                        helperText={
                                          typeof validationErrors[index] !==
                                            "undefined" &&
                                          validationErrors.length > 0
                                            ? validationErrors[index].dwg_no
                                            : ""
                                        }
                                      />
                                    </Grid>

                                    <Grid item xs={12} sm={6} lg={6}>
                                      <TextField
                                        id={"rev_no_" + index}
                                        name="rev_no"
                                        label="Revision No."
                                        required
                                        disabled={
                                          drawingRes.attrs.publish_type ===
                                            "REMOVE" ||
                                          drawingRes.attrs.publish_type ===
                                            "AI_COVER" ||
                                          drawingRes.attrs.publish_type ===
                                            "BD_COVER"
                                            ? true
                                            : false
                                        }
                                        fullWidth={true}
                                        size="small"
                                        variant="outlined"
                                        value={drawingRes.attrs.rev_no}
                                        onChange={handleTextChange(index)}
                                        // InputLabelProps={{
                                        // 	shrink: true,
                                        // }}
                                        error={
                                          typeof validationErrors[index] !==
                                            "undefined" &&
                                          validationErrors.length > 0
                                            ? validationErrors[index].rev_no &&
                                              validationErrors[index].rev_no !==
                                                ""
                                              ? true
                                              : false
                                            : false
                                        }
                                        helperText={
                                          typeof validationErrors[index] !==
                                            "undefined" &&
                                          validationErrors.length > 0
                                            ? validationErrors[index].rev_no
                                            : ""
                                        }
                                      />
                                    </Grid>

                                    <Grid item xs={12} sm={12} lg={12}>
                                      <TextField
                                        id={"dwg_title_" + index}
                                        name="dwg_title"
                                        label="Drawing Title"
                                        required
                                        disabled={
                                          drawingRes.attrs.publish_type ===
                                            "REMOVE" ||
                                          drawingRes.attrs.publish_type ===
                                            "AI_COVER" ||
                                          drawingRes.attrs.publish_type ===
                                            "BD_COVER"
                                            ? true
                                            : false
                                        }
                                        fullWidth={true}
                                        size="small"
                                        variant="outlined"
                                        value={drawingRes.attrs.dwg_title}
                                        onChange={handleTextChange(index)}
                                        // InputLabelProps={{
                                        // 	shrink: true,
                                        // }}
                                        error={
                                          typeof validationErrors[index] !==
                                            "undefined" &&
                                          validationErrors.length > 0
                                            ? validationErrors[index]
                                                .dwg_title &&
                                              validationErrors[index]
                                                .dwg_title !== ""
                                              ? true
                                              : false
                                            : false
                                        }
                                        helperText={
                                          typeof validationErrors[index] !==
                                            "undefined" &&
                                          validationErrors.length > 0
                                            ? validationErrors[index].dwg_title
                                            : ""
                                        }
                                      />
                                    </Grid>

                                    <Grid item xs={12} sm={12} lg={12}>
                                      <FormControl
                                        required
                                        variant="outlined"
                                        size="small"
                                        className={classes.formControl}
                                        error={
                                          typeof validationErrors[index] !==
                                            "undefined" &&
                                          validationErrors.length > 0
                                            ? validationErrors[index]
                                                .dwg_type_group &&
                                              validationErrors[index]
                                                .dwg_type_group !== ""
                                              ? true
                                              : false
                                            : false
                                        }
                                      >
                                        <InputLabel id="dwg-type-group-label">
                                          DWG Type Group
                                        </InputLabel>
                                        <Select
                                          id={"dwg_type_group_" + index}
                                          labelId="dwg_type_group_label"
                                          label="DWG Type Group"
                                          value={
                                            drawingRes.attrs.dwg_type_group
                                          }
                                          disabled={
                                            drawingRes.attrs.publish_type ===
                                              "REMOVE" ||
                                            drawingRes.attrs.publish_type ===
                                              "AI_COVER" ||
                                            drawingRes.attrs.publish_type ===
                                              "BD_COVER"
                                              ? true
                                              : false
                                          }
                                          onChange={handleChangeDwgTypeGroup(
                                            index
                                          )}
                                          // InputLabelProps={{
                                          // 	shrink: false,
                                          // }}

                                          MenuProps={{
                                            getContentAnchorEl: null,
                                            anchorOrigin: {
                                              vertical: "bottom",
                                              horizontal: "left",
                                            },
                                          }}
                                        >
                                          {dwgTypeGroupAndType
                                            ? dwgTypeGroupAndType.map((res) => {
                                                return (
                                                  <SelectMenuItem
                                                    key={res.type_group_seq}
                                                    value={res.type_group_seq}
                                                  >
                                                    {res.type_group_name}
                                                  </SelectMenuItem>
                                                );
                                              })
                                            : ""}
                                        </Select>
                                        <FormHelperText>
                                          {typeof validationErrors[index] !==
                                            "undefined" &&
                                          validationErrors.length > 0
                                            ? validationErrors[index]
                                                .dwg_type_group
                                            : ""}
                                        </FormHelperText>
                                      </FormControl>
                                    </Grid>

                                    <Grid item xs={12} sm={12} lg={12}>
                                      <FormControl
                                        required
                                        variant="outlined"
                                        size="small"
                                        className={classes.formControl}
                                        error={
                                          typeof validationErrors[index] !==
                                            "undefined" &&
                                          validationErrors.length > 0
                                            ? validationErrors[index]
                                                .dwg_types &&
                                              validationErrors[index]
                                                .dwg_types !== ""
                                              ? true
                                              : false
                                            : false
                                        }
                                      >
                                        <InputLabel id="dwg-type-label">
                                          DWG Type
                                        </InputLabel>
                                        <Select
                                          id="dwg_types"
                                          labelId="dwg_type_label"
                                          label="DWG Type"
                                          value={
                                            drawingRes.attrs.dwg_type_names
                                          }
                                          multiple
                                          disabled={
                                            drawingRes.attrs.publish_type ===
                                              "REMOVE" ||
                                            drawingRes.attrs.publish_type ===
                                              "AI_COVER" ||
                                            drawingRes.attrs.publish_type ===
                                              "BD_COVER"
                                              ? true
                                              : false
                                          }
                                          onChange={handleChangeDwgType(index)}
                                          MenuProps={{
                                            getContentAnchorEl: null,
                                            anchorOrigin: {
                                              vertical: "bottom",
                                              horizontal: "left",
                                            },

                                            classes: {
                                              paper: classes.menuPaper,
                                            },
                                          }}
                                          renderValue={(selected) => (
                                            <div className={classes.chips}>
                                              {selected.map((value) => (
                                                <Chip
                                                  key={value}
                                                  label={value}
                                                  className={classes.chip}
                                                />
                                              ))}
                                            </div>
                                          )}
                                        >
                                          {dwgType
                                            ? dwgType.map((res) => (
                                                <SelectMenuItem
                                                  key={res.type_seq}
                                                  id={res.type_seq}
                                                  value={res.type_name}
                                                >
                                                  {res.type_name}
                                                </SelectMenuItem>
                                              ))
                                            : ""}
                                        </Select>
                                        <FormHelperText>
                                          {typeof validationErrors[index] !==
                                            "undefined" &&
                                          validationErrors.length > 0
                                            ? validationErrors[index].dwg_types
                                            : ""}
                                        </FormHelperText>
                                      </FormControl>
                                    </Grid>

                                    <Grid item xs={10} sm={10} lg={10}>
                                      <TextField
                                        id={"dwg_tag_" + index}
                                        name="dwg_tag"
                                        label="Drawing Tag"
                                        disabled={
                                          drawingRes.attrs.publish_type ===
                                            "REMOVE" ||
                                          drawingRes.attrs.publish_type ===
                                            "AI_COVER" ||
                                          drawingRes.attrs.publish_type ===
                                            "BD_COVER"
                                            ? true
                                            : false
                                        }
                                        fullWidth={true}
                                        size="small"
                                        variant="outlined"
                                        value={dwgTagName}
                                        onChange={handleTextChangeDwgTag}
                                        onKeyPress={handleAddTags(index)}
                                        // InputLabelProps={{
                                        // 	shrink: true,
                                        // }}
                                        // error={validationErrors.cover_no && validationErrors.cover_no !== "" ? true : false}
                                        // helperText={validationErrors.cover_no}
                                      />
                                    </Grid>

                                    <Grid item xs={2} sm={2} lg={2}>
                                      <Tooltip title="Add Tag">
                                        <span>
                                          <Fab
                                            aria-label="add_Tag"
                                            color="primary"
                                            size="small"
                                            disabled={
                                              drawingRes.attrs.publish_type ===
                                                "REMOVE" ||
                                              drawingRes.attrs.publish_type ===
                                                "AI_COVER" ||
                                              drawingRes.attrs.publish_type ===
                                                "BD_COVER"
                                                ? true
                                                : false
                                            }
                                            onClick={handleAddTags(index)}
                                            className={classes.tagBtn}
                                          >
                                            <AddIcon />
                                          </Fab>
                                        </span>
                                      </Tooltip>
                                    </Grid>

                                    <Grid item xs={12} sm={12} lg={12}>
                                      <Paper
                                        variant="outlined"
                                        className={classes.tagArea}
                                      >
                                        {drawingRes
                                          ? drawingRes.attrs.dwg_tags.map(
                                              (tag, i) => {
                                                return (
                                                  <Chip
                                                    key={i}
                                                    label={tag}
                                                    icon={<LocalOfferIcon />}
                                                    variant="outlined"
                                                    size="small"
                                                    disabled={
                                                      drawingRes.attrs
                                                        .publish_type ===
                                                        "REMOVE" ||
                                                      drawingRes.attrs
                                                        .publish_type ===
                                                        "AI_COVER" ||
                                                      drawingRes.attrs
                                                        .publish_type ===
                                                        "BD_COVER"
                                                        ? true
                                                        : false
                                                    }
                                                    // color="primary"
                                                    onDelete={handleTagDelete(
                                                      index,
                                                      tag
                                                    )}
                                                    style={{
                                                      paddingLeft: 5,
                                                      paddingRight: 0,
                                                      paddingTop: 5,
                                                      paddingBottom: 5,
                                                      marginRight: 10,
                                                    }}
                                                  />
                                                );
                                              }
                                            )
                                          : ""}
                                      </Paper>
                                    </Grid>

                                    <Grid item xs={12} sm={12} lg={12}>
                                      <div className={classes.applyBtnGroup}>
                                        <Tooltip title="Copy this form value to all">
                                          <span>
                                            <Fab
                                              aria-label="apply_all"
                                              color="primary"
                                              size="small"
                                              disabled={
                                                drawingRes.attrs
                                                  .publish_type === "REMOVE" ||
                                                drawingRes.attrs
                                                  .publish_type ===
                                                  "AI_COVER" ||
                                                drawingRes.attrs
                                                  .publish_type === "BD_COVER"
                                                  ? true
                                                  : false
                                              }
                                              onClick={applyAllConfirmAction(
                                                index
                                              )}
                                              className={classes.applyBtn}
                                            >
                                              <ReplayIcon />
                                            </Fab>
                                          </span>
                                        </Tooltip>

                                        <Tooltip title="Copy this form value to selected">
                                          <span>
                                            <Fab
                                              aria-label="apply_selected"
                                              color="primary"
                                              size="small"
                                              disabled={
                                                drawingRes.attrs
                                                  .publish_type === "REMOVE" ||
                                                drawingRes.attrs
                                                  .publish_type ===
                                                  "AI_COVER" ||
                                                drawingRes.attrs
                                                  .publish_type === "BD_COVER"
                                                  ? true
                                                  : false
                                              }
                                              onClick={applySelectedConfirmAction(
                                                index
                                              )}
                                              className={classes.applyBtn}
                                            >
                                              <RotateLeftIcon />
                                            </Fab>
                                          </span>
                                        </Tooltip>
                                      </div>
                                    </Grid>
                                  </Grid>
                                ) : (
                                  ""
                                )}
                              </AccordionDetails>
                            </Accordion>
                          );
                        }
                      )}
                    </MuiThemeProvider>
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} lg={8}>
                  <div className={classes.viewerArea}>
                    <WebViewer
                      property={webViewerProps}
                      localFile={false}
                      ocr={true}
                      zoom={175}
                      move={{ x: 10000, y: 5000 }}
                    />
                  </div>
                </Grid>
              </Grid>
            </div>
          ) : (
            ""
          )}
        </div>
      </Fragment>
    )
  );
};

export default UnpublishDetail;
